import React, {Component} from 'react'
import Panel from '../Panel'
import {style, media, merge} from 'glamor'
import * as colors from '../../colors'
import Page from './Page'
import PageTitle from '../PageTitle'
import SectionTitle from '../SectionTitle'
import Emoji from '../Emoji'

const budgets = [
  {
    rate: 2,
    text: "Petits budgets, conseils, idées..."
  },
  {
    rate: 3,
    text: "Plus conséquent, plus d’intervenants..."
  },
  {
    rate: 4,
    text: "Chaque expert a un rôle justifié, défini et budgeté."
  },
  {
    rate: 5,
    text: "Conception, réalisation, livraison... On peut tout faire à la demande!"
  }
]

export default class extends Component {

  shouldComponentUpdate(){
    return false
  }

  render(){
    return (
      <Page>
        <PageTitle>Philosophie</PageTitle>

        <SectionTitle data-animate>Le fonctionnement</SectionTitle>

        <div data-animate>
        <table
          {...style({
            width:'100%',
            marginBottom: '1rem',
            color: colors.lightSilver
          })}
        >
          <tbody>
            {budgets.map(({rate, text}, i)=>(
              <tr key={i} >
                <td
                  {...style({
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    paddingRight: '1rem'
                  })}
                >
                  {Array(rate).fill().map((_, j)=>
                    (<Emoji key={j}/>)
                  )}
                </td>
                <td>{text}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>

        <div
          data-animate
          {...merge(
            style({
              marginBottom: '2rem'
            }),
            media('(min-width:800px)', {
              marginBottom: '4rem'
            })
          )}
        >
          Notre mission s’arrête lorsque vous n’avez plus besoin de nous.
        </div>

        <div
          data-animate
          {...style({
            display: 'flex',
            justifyContent: 'flex-end'
          })}
        >
          <Panel
            {...media('(min-width: 1200px)',{
              width: '70%'
            })}
          >
            <p>
              Les petits budgets n’existent pas dans le système Buyideas, et les gros budgets sont utilisés au plus juste. Il n’y a que des sommes d’argent à utiliser au mieux dans un objectif donné. Je crée des équipes en fonction des sujets et des budgets.
            </p>
            <p>
              Tout le monde s’y retrouve, ceux pour qui je travaille comme ceux avec qui je travaille. Créatifs, web designers, commerciaux, tv prod, photographes, réalisateurs, illustrateurs, tous sont talentueux, responsables et indépendants. Ils sont aussi habitués aux équipes souples et aux contrats courts. Ah, un détail qui est très important pour moi, je ne travaille qu’avec des gens sympa et positifs
            </p>
          </Panel>
        </div>

      </Page>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/Philosophy.js
 **/